/**
 * Created by Shannon on 2017-05-13.
 */

const divStyle = {
    fontFamily: "Arial Rounded MT Bold",
    textShadow: "5px 2px 1px white",
    fontSize: 20
};

const animalAgeFactors = {
    "cat": 3.2,
    "dog": 3.64,
    "horse" : 5,
    "hamster": 20,
    "rabbit": 8.89,
    "parakeet": 4.44,
    "mouse": 20,
    "rat": 26.67,
    "pig": 3.2,
    "goat": 5.33
};

const images = {
    "cat": "https://image.ibb.co/i9ppWR/cat.png",
    "dog": "https://image.ibb.co/ccqJQm/dog.png",
    "horse": "https://image.ibb.co/mn4Ckm/horse.png",
    "hamster": "https://image.ibb.co/ig7nJ6/hamster.png",
    "rabbit": "https://image.ibb.co/dUZCkm/rabbit.png",
    "parakeet": "https://image.ibb.co/n141d6/bird.png",
    "mouse": "https://image.ibb.co/eVkJQm/mouse.png",
    "rat": "https://image.ibb.co/frfPy6/rat.png",
    "pig": "https://image.ibb.co/fXFJQm/pig.png",
    "goat": "https://image.ibb.co/ckKZy6/goat.png"

};

module.exports = {animalAgeFactors: animalAgeFactors, images: images, divStyle: divStyle};



// WEBPACK FOOTER //
// ./src/components/Data.js